import { View } from "binder"
import { IbanSelectorSelectorViewModel } from "src/erp/arap/rawData/ibanSelector-viewModel";
import { IbanGatewayViewModel } from "./ibanGateway-viewModel"

export class IbanGatewayView extends View<IbanGatewayViewModel>{
    GetViewUniqueId(): string {
        return "V-ED53F6B2-4EBB-4A62-833F-BD46196A0D00"
    }
    loadHtml(): string {
        let element = require('./ibanGateway.html').default;
        let style = require('./ibanGateway.less');
        return element;
    }
    constructor() {
       super();
    }
    public set accountSelector(v: IbanSelectorSelectorViewModel) { this._accountSelector = v; } public get accountSelector(): IbanSelectorSelectorViewModel { return this._accountSelector;} private _accountSelector: IbanSelectorSelectorViewModel;
    public set traceCode(v: string) { this._traceCode = v; } public get traceCode(): string { return this._traceCode;} private _traceCode: string;

}
